import { Pipe } from '@angular/core';
import { isArray, getProperty } from '../utils/utils';
var PluckPipe = (function () {
    function PluckPipe() {
    }
    PluckPipe.prototype.transform = function (input, key) {
        if (!isArray(input) || !key) {
            return input;
        }
        return input.map(function (value) {
            return getProperty(value, key);
        });
    };
    return PluckPipe;
}());
export { PluckPipe };
PluckPipe.decorators = [
    { type: Pipe, args: [{
                name: 'pluck'
            },] },
];
/** @nocollapse */
PluckPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=pluck.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/pluck.pipe.js
// module id = 243
// module chunks = 103